import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useDateRange,
  useMultiDivisionMultiSectionDropdown,
  useProvidersCurrentEmployee,
  useApisAnalyticsPlansRoleplayingConditionsIndex,
  usePrevNextSelectMonth,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { AnalyticsRoleplayingConditionsTemplate } from "~/components/templates";

const today = new Date();

export const AnalyticsPlansRoleplayingConditionsIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [
    {
      label: "ロールプレイング分析",
      href: "/analytics_plans/roleplaying_conditions",
    },
  ];

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
    selectableEmployees,
    selectedEmployee,
    onEmployeeChange,
  } = useMultiDivisionMultiSectionDropdown({
    selectableDivisions: currentEmployee?.businessDivisions,
    selectableSections: currentEmployee?.businessSections,
    isSelectEmployee: true,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      formattedEndDate,
      dateArray,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const {
    targetDate,
    targetDateString,
    handlePrevMonthClick,
    handleNextMonthClick,
  } = usePrevNextSelectMonth();

  const { data, isLoading } = useApisAnalyticsPlansRoleplayingConditionsIndex({
    params: {
      businessDivisionIds: selectedDivisions.map((division) => division.id),
      businessSectionIds: optionSelectedSections.map((section) => section.id),
      fromDate: formattedStartDate || undefined,
      toDate: formattedEndDate || undefined,
      targetDate: targetDateString,
      employeeIds: selectedEmployee ? [selectedEmployee.id] : undefined,
    },
    config: {
      enabled: !!(formattedStartDate && formattedEndDate),
    },
  });

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <AnalyticsRoleplayingConditionsTemplate
            formattedStartDate={formattedStartDate}
            formattedEndDate={formattedEndDate}
            selectedDivisions={selectedDivisions}
            optionSelectedSections={optionSelectedSections}
            data={data}
            isLoading={isLoading}
            onChangeDateRange={onChangeDateRange}
            onDivisionChange={onDivisionChange}
            onSectionChange={onSectionChange}
            selectableDivisions={selectableDivisions}
            optionSelectableSections={optionSelectableSections}
            startDate={startDate}
            endDate={endDate}
            selectedDropdownSections={optionSelectedSections}
            dateArray={dateArray}
            selectedEmployee={selectedEmployee}
            onEmployeeChange={onEmployeeChange}
            selectableEmployees={selectableEmployees}
            targetDate={targetDate}
            handlePrevMonthClick={handlePrevMonthClick}
            handleNextMonthClick={handleNextMonthClick}
          />
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
